import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { observer , inject } from 'mobx-react';
import agent from '../../../api/agent';


class ProductDetails extends Component {

    html = ''

    constructor(props){
        super(props);
        this.ModalContent = React.createRef();
    }

    componentDidMount(){
        this.fetchExternalHTML()
    }
    fetchExternalHTML() {
        const { club_number,club_product_id}  = this.props.DGRStore
        agent.DGR.externalHTMLProductPages(club_number, club_product_id).then( (response) => {
            this.html = response
            this.forceUpdate()
            var tabBar = ReactDOM.findDOMNode( this.ModalContent.current ).querySelector('.tabBar');
            var tabBody = ReactDOM.findDOMNode( this.ModalContent.current ).querySelector('.body');
            if ( tabBar && tabBody ) {
                this.initTabs( tabBar, tabBody );
            }
        })
    }

    initTabs( tabBar, tabBody ) {
        var tabContents = {},
            tabLinks = {};
        tabContents['price'] = tabBody.getElementsByClassName('priceBody')[0];
        tabContents['membership'] = tabBody.getElementsByClassName('membershipBody')[0];
        tabContents['club'] = tabBody.getElementsByClassName('clubBody')[0];
        tabLinks['price'] = document.getElementById('priceTab');
        tabLinks['membership'] = document.getElementById('membershipTab');
        tabLinks['club'] = document.getElementById('clubTab');
        tabBar.getElementsByClassName('tab').forEach( tab => {
            tab.onclick = function() {
                selectTab( this.getAttribute( 'data-tab' ) );
            }
        });

        function selectTab( thisTab ) {
            for ( var tabName in tabContents ) {
                tabContents[ tabName ].style.display = 'none';
            }
            for ( var tabName2 in tabLinks ) {
                tabLinks[ tabName2 ].style.background = '#ffffff';
            }
            tabContents[ thisTab ].style.display = 'block';
            tabLinks[ thisTab ].style.background = '#D52B1E';
        }

        selectTab('price');
    }

    createMarkup(){
        if (this.html){
            return { __html: this.html }
        }else{
            return {__html: '<div class="ext"></div>'};
        }
    }
    render() {
        if (this.html){
            return(
                <div>
                    <div ref={this.ModalContent} dangerouslySetInnerHTML={this.createMarkup()}/>
                </div>
            )
        }else{
            return (
                <div>
                    Loading...
                </div>
            )
        }
    }
}

ProductDetails = inject('DGRStore','DGRModalStore')(observer(ProductDetails))     
export default ProductDetails;





// WEBPACK FOOTER //
// ./src/components/DGR/Modal/ProductDetails.js